// extracted by mini-css-extract-plugin
module.exports = {"divider":"Divider_divider__h03d0","divider--white":"Divider_divider--white__QD8ZO"};